import { render, staticRenderFns } from "./VTableColumn.vue?vue&type=template&id=77a0f9bd&"
import script from "./VTableColumn.vue?vue&type=script&lang=js&"
export * from "./VTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports